import Slide from "../../../../../../components/Slide";
import QList from "../../../../../../components/QList";
import QHeader from "../../../../../../components/QHeader";

import BackgroundImage from "../../../../../../assets/_Chapters/_Images/background/BeratungPlanungMontage/2.webp";
import { Grid } from "@material-ui/core";

export default function Beschaffung() {
  return (
    <Slide
      background={{
        image: BackgroundImage,
        width: "50dvw",
        align: "right",
        position: "center",
      }}
    >
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={6}>
          <QHeader title="Beschaffung – alles aus einer Hand" />
          <QList
            items={[
              "Perfekte Produkt- und Lösungsauswahl",
              "Termingerechte Abwicklung",
              "Herstellerunabhängige Materialbeschaffung",
            ]}
          />
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    </Slide>
  );
}
